import iconPrestamo from './prestamo.svg';
import iconSaldos from './saldoMovimiento.svg';
import iconPortafolio from './iconPortafolio.svg';
import elipseLleno from './elipseLleno.svg';
import elipseVacio from './elipseVacio.svg';
import solicitudAprobada  from './solicitudAprobada.svg';
import rebalanceoInversion from './iconoRebalanceo.svg';
import exitoRebalanceo  from './exitoRebalanceo.svg';
import noDisponible  from './nodisponible.svg';
import txtNoDisponible from './txtNoDisponible.svg';
import constanciaFiscal from './constanciaFiscal.svg';
import cancelar from './cancelar.svg';
import errorRebalanceo  from './errorRebalanceo.svg';
import txtErrorPorcentaje from './txtErrorPorcentaje.svg';
import txtErrorGRebalanceo from './txtErrorGRebalanceo.svg';
import checkOutline from './checkOutline.svg';
import sinInfo from './SinInfo.svg';
import exitoSolicitud from './exitoSolicitud.svg';
import limitePrestamo from './limitePrestamo.svg';
import mantenimientoimg from './mantenimiento.svg';

//carousel
import calculaPension from './calcula_pension.svg';
import educacionFinanciera from './educacion_financiera.svg';
import leftArrow from './leftArrowCarousel.svg';
import rightArrow from './rightArrowCarousel.svg';
import conoceMas from './conoceMas.svg';
import txtSaludFinanciera from './txtSaludFinanciera.svg';

import candado from './candado.svg';


export const ICONS = {
    iconPrestamo,
    iconSaldos,
    iconPortafolio,
    elipseLleno,
    elipseVacio,
    solicitudAprobada,
    rebalanceoInversion,
    exitoRebalanceo,
    noDisponible,
    txtNoDisponible,
    constanciaFiscal,
    cancelar,
    errorRebalanceo,
    txtErrorPorcentaje,
    txtErrorGRebalanceo,
    checkOutline,
    sinInfo,
    exitoSolicitud,
    limitePrestamo,
    mantenimientoimg,
    calculaPension,
    educacionFinanciera,
    leftArrow,
    rightArrow, 
    conoceMas,
    txtSaludFinanciera, 
    candado
}